// src/context/ModalContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        isOpen: false,
        type: 'alert', // 'alert' or 'confirm'
        title: '',
        message: '',
        onConfirm: null,
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        isDestructive: false // If true, confirm button is red
    });

    const close = useCallback(() => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    }, []);

    const showAlert = useCallback((message, title = 'Notice') => {
        setModalState({
            isOpen: true,
            type: 'alert',
            title,
            message,
            onConfirm: close
        });
    }, [close]);

    // ✅ ADDED confirmText and cancelText parameters
    const showConfirm = useCallback((message, onConfirm, title = 'Confirm Action', isDestructive = false, confirmText = 'Confirm', cancelText = 'Cancel') => {
        setModalState({
            isOpen: true,
            type: 'confirm',
            title,
            message,
            onConfirm: () => {
                if (onConfirm) onConfirm();
                close();
            },
            confirmText, // ✅ Pass to state
            cancelText,  // ✅ Pass to state
            isDestructive
        });
    }, [close]);

    return (
        <ModalContext.Provider value={{ modalState, close, showAlert, showConfirm }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);